import { useIntl } from 'react-intl'
import Icon from '../../../../../../components/Icon/Icon'
import Typography from '../../../../../../components/Typography/Typography'

import './TicketRowHeader.scss'

//TODO i18n

const TicketRowHeader = ({ firstMovie, onClick }) => {
    const intl = useIntl()

    return (
        <div className={'ticket-row-header'}>
            <div className="row-ticket-part">
                <div className={'header-container'}>
                    <Typography variant={'label'}>{'Sedadlo'}</Typography>
                </div>
                <div className={'header-container'}>
                    <Typography variant={'label'}>{'Cena'}</Typography>
                </div>
            </div>
            <div className="row-toggle-btn-row-part">
                <div className={'header-container d-flex gap-1'}>
                    <Typography variant={'label'}>{'Typ vstupenky'}</Typography>
                    {firstMovie && <Icon name={'info-lightblue'} role={'button'} onClick={onClick} />}
                </div>
            </div>
            <div className="row-icon-part"></div>
        </div>
    )
}

export default TicketRowHeader
